import { createSlice } from '@reduxjs/toolkit';

interface Message {
	code: string;
	message: string;
}

interface MessageState {
	message: Message;
}

const errorSlice = createSlice({
	name: 'message',
	initialState: {
		message: {},
	} as MessageState,
	reducers: {
		setMessage: (state, action) => {
			state.message = {
				code: action.payload.code,
				message: action.payload.message,
			};
		},
	},
});

const { reducer, actions } = errorSlice;

export const { setMessage } = actions;
export default reducer;
